/*
 * Lumibrace photo-safe uploads.
 * Android (Google Photos / gallery) hands the browser a temporary link to the
 * picked photo. When the cart form is submitted later, that link has often
 * changed and Chrome aborts with ERR_UPLOAD_FILE_CHANGED.
 * Fix: the moment a photo is picked we read it fully into memory (and shrink
 * very large photos), put that in-memory copy back into the input, and only then
 * let the theme's own change handlers run. Every later submit uses the safe copy.
 */
(function () {
  if (window.__lumiPhotoSafe) return;
  window.__lumiPhotoSafe = true;
  if (typeof DataTransfer === 'undefined' || typeof FileReader === 'undefined') return;

  var MAX_SIDE = 1600;
  var SHRINK_OVER = 400 * 1024; // shrink almost every phone photo → fast uploads in Meta/IG/TikTok WebViews

  function readBuffer(file) {
    if (file.arrayBuffer) return file.arrayBuffer();
    return new Promise(function (res, rej) {
      var r = new FileReader();
      r.onload = function () { res(r.result); };
      r.onerror = function () { rej(r.error); };
      r.readAsArrayBuffer(file);
    });
  }

  function shrink(blob, name) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var scale = Math.min(1, MAX_SIDE / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.round(w * scale); c.height = Math.round(h * scale);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(function (out) {
            URL.revokeObjectURL(url);
            if (!out || out.size >= blob.size) return resolve(null);
            resolve(new File([out], name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg', lastModified: Date.now() }));
          }, 'image/jpeg', 0.82);
        } catch (e) { URL.revokeObjectURL(url); resolve(null); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
      img.src = url;
    });
  }

  function makeSafe(file) {
    return readBuffer(file).then(function (buf) {
      var type = file.type || 'image/jpeg';
      var name = file.name || 'photo.jpg';
      var copy = new File([buf], name, { type: type, lastModified: Date.now() });
      if (copy.size > SHRINK_OVER && /^image\/(jpeg|png|webp|heic|heif)/i.test(type)) {
        return shrink(copy, name).then(function (s) { return s || copy; });
      }
      return copy;
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'file') return;
    if (e.__lumiSafe) return; // our own re-dispatched event
    var files = input.files;
    if (!files || !files.length) return; // cleared → let theme handle normally

    e.stopImmediatePropagation();
    input.setAttribute('data-photo-reading', '1');
    var list = Array.prototype.slice.call(files);
    var job = Promise.all(list.map(makeSafe)).then(function (safe) {
      var dt = new DataTransfer();
      safe.forEach(function (f) { dt.items.add(f); });
      input.files = dt.files;
    }).catch(function (err) {
      console.warn('[lumi] photo read failed', err);
      input.value = '';
      alert('לא הצלחנו לקרוא את התמונה, נסו לבחור שוב');
    }).then(function () {
      input.removeAttribute('data-photo-reading');
      var ev = new Event('change', { bubbles: true });
      ev.__lumiSafe = true;
      input.dispatchEvent(ev);
    });
    input.__lumiReady = job;
  }, true);

  // Don't let a cart submit leave while a photo is still being read.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var busy = document.querySelector('input[type=file][data-photo-reading]');
    if (busy && form.id !== 'lumi-buy-form' && (busy.form === form || form.contains(busy))) {
      e.preventDefault(); e.stopImmediatePropagation();
      alert('התמונה עדיין נטענת, נסו שוב בעוד רגע');
    }
  }, true);
})();
